
export const type= 'GET-RECIPES-FAVORITE'
const GetRecipesFavorites = ()=>({
    type
})
export default GetRecipesFavorites